<template>
  <div class="main-assessoria-digital" tag="section">
    <div id="header">
      <div class="img__header">
        <div class="bg__escuro"></div>
        <div class="bg__title">
          <h2 class="text-title">Assessoria Pedagógica</h2>
        </div>
      </div>
    </div>
    <BreadSistema />
    <b-container fluid="lg" class="py-2 pb-4">
      <b-card class="shadow-sm" tag="article" no-body>
        <b-card-header header-bg-variant="transparent">
          <h1 class="display-6">Informações Pessoais</h1>
          <p class="lead mt-2">Preencha com cuidado as informações, será atráves delas que entraremos em contato.</p>
        </b-card-header>
        <b-card-body>
          <b-form @submit.prevent="handleSubmit">
            <b-form-row>
              <b-col cols="12" sm="12" md="6" lg="4" xl="4">
                <b-form-group label="Nome:" label-for="input-name" label-class="my-1">
                  <b-input-group>
                    <b-input type="text" v-model.trim="nome" @input="!$v.nome.$touch()" placeholder="Digite o nome completo" :state="nameState ? true : this.$v.nome.$error ? false : null" required></b-input>
                    <b-input-group-append is-text>
                      <i class="fas fa-user"></i>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="12" md="6" lg="4" xl="4">
                <b-form-group label="E-mail:" label-for="input-email" label-class="my-1">
                  <b-input-group>
                    <b-input type="email" v-model.trim="email" @input="!$v.email.$touch()" :formatter="formatterEmail" :aria-invalid="!emailState" placeholder="exemplo@dominio.com.br" :state="emailState ? true : this.$v.email.$error ? false : null" required></b-input>
                    <b-input-group-append is-text>
                      <i class="fas fa-envelope"></i>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="12" md="6" lg="4" xl="4">
                <b-form-group label="Celular:" label-for="input-celular" label-class="my-1">
                  <b-input-group>
                    <b-input type="tel" v-model.trim="celular" @input="!$v.celular.$touch()" :aria-invalid="celularState" v-mask="'(##) #####-####'" placeholder="(##) #####-####" :state="celularState ? true : this.$v.celular.$error ? false : null" required></b-input>
                    <b-input-group-append is-text>
                      <i class="fas fa-phone"></i>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6" lg="12" xl="12">
                <b-form-group label="Deseja contato por Whatsapp?" label-for="input-whats" label-class="my-1">
                  <b-form-radio-group v-model="aceiteWhatts" :options="optionAceite" value-field="item" text-field="name"></b-form-radio-group>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="Qual o ser cargo na escola?" label-for="input-whats" label-class="my-2">
                  <b-form-radio-group v-model="cargo" :options="cargos" value-field="item" text-field="name"></b-form-radio-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="12" md="5" lg="5" xl="5" v-if="cargo == 'outro'">
                <b-form-group label="Se outro, qual?" label-for="input-outros" label-class="my-2">
                  <b-input-group>
                    <b-input type="tel" v-model.trim="outroEsp" :required="cargo === 'outro'"></b-input>
                    <b-input-group-append is-text>
                      <i class="fas fa-briefcase"></i>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                  <div class="d-flex justify-content-center" v-if="spin">
                    <b-spinner type="grow" label="Spinning"></b-spinner>
                  </div>
                  <div class=" d-flex justify-content-center my-3 justify-content-lg-end my-lg-0" v-if="!spin">
                    <b-button type="submit" class="btn-send" variant="transparent" :disabled="cargo == ''">Enviar</b-button>
                  </div>
              </b-col>
              <b-col cols="12" sm="12" md="12" lg="12" xl="12" class="border-top border-bottom border-light py-3 my-2">
                <p>Todas as informações pessoais recolhidas, serão usadas para o ajudar a tornar a sua visita em nosso site mais produtiva e agradável possível.</p>
                <p>A garantia da confidencialidade dos dados pessoais dos utilizadores do nosso site é importante para o <strong>Sistema de Ensino CPV</strong></p>
                <p>Todas as informações pessoais relativas a membros, assinantes, clientes ou visitantes que usem o <strong>Sistema de Ensino CPV</strong> serão tratados em corcordância com a <strong>Lei de Proteção de Dados (LGPD) de 26 de outubro de 1998 (Lei Nº 67/98).</strong></p>
                <div class="d-flex align-items-center justify-content-center">
                  <b-button href="https://intranet.cpv.com.br/compliance#/app" variant="transparent">Relatar abuso</b-button>
                </div>
              </b-col>
            </b-form-row>
          </b-form>
        </b-card-body>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import ApiService from '@/common/api.service'
import { required, minLength, email, helpers } from 'vuelidate/lib/validators';

export default {
  name: 'AsseroriaPedagogica',
  metaInfo: { title: 'Assessoria Pedagógica' },
  components: { BreadSistema: () => import('@/components/GlobalComponents/bread-sistema.vue') },
  validations: {
    nome: { required, minLength: minLength(3) },
    email: { required, email },
    celular: { required, minLength: minLength(15) },
    aceiteWhatts: { required },
    cargo: { required },
    outroEsp: {
        required: helpers.withParams(
        { type: 'requiredIfCargoOutro' },
        function (val, vm) {
          return vm.cargo === 'outro' ? required(val) : true
        } 
      )
    }
  },
  data: () => {
    return {
      spin: false,

      nome: '',
      email: '',
      celular: '',
      aceiteWhatts: '',
      cargo: '',
      outro: '',
      outroEsp: '',

      submitted: false,
      error: '',

      assessoria: {
        data: [],
      },
      optionAceite: [{ item: 'sim', name: 'Sim' }, { item: 'nao', name: 'Não' }],
      cargos: [
        { item: 'diretoria', name: 'Diretor(a)' },
        { item: 'coordenador', name: 'Coordenador(a)' },
        { item: 'professor', name: 'Professor(a)' },
        { item: 'mantenedor', name: 'Mantenedor(a)' },
        { item: 'outro', name: 'Outro' },
      ],
    };
  },
  computed: {
    nameState() {
      if (this.$v.nome.$pending) return null;
      return !this.$v.nome.$error && this.nome.length > 2;
    },
    emailState() {
      if (!this.email) return null;
      if (this.$v.email.$pending) return null;

      return !this.$v.email.$error;
    },

    celularState() {
      if (!this.celular) return null;
      if (this.$v.celular.$pending) return null;
      return !this.$v.celular.$error;
    },

    aceiteWhatsState() {
      if (!this.aceiteWhatts) return null;
      if (this.$v.aceiteWhatts.$pending) return null;

      return !this.$v.aceiteWhatts.$error;
    },
    cargoState() {
      return !!this.cargo || this.$v.cargo.$error;
    },
  },
  methods: {
    formatterEmail(value) {
      return value.toLowerCase();
    },

    handleSubmit(e) {
      this.spin = true;
      this.submitted = true;
      this.$v.$touch();

      let validation = this.$v.$invalid;

      if (validation) {
        setTimeout(() => {
          console.log('válido?', !this.$v.$invalid)
          this.spin = false
        }, 1500)
        return;
      }

      this.postData()
    },
    postData() {
      ApiService.post('v1/assessoriaPedagogica', {
        nome: this.nome,
        email: this.email,
        celular: this.celular,
        aceiteWhatts: this.aceiteWhatts,
        cargo: this.cargo,
        outro: this.outro,
        outroEsp: this.outroEsp,
        protocolo: this.protocolo(),
      })
        .then((response) => {
          this.assessoria = response;
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          var oNome = this.nome;
          var tmp = oNome.split(' ');
          oNome = tmp[0]; //+ " " + tmp[1];
          this.spin = false;
          this.$router.push({
              name: 'thanks',
              params: {
              nome: oNome,
            },
          });
        });
    },
    protocolo: function () {
      var data = new Date();
      return (
        ('0' + data.getDate()).substr(-1) +
        ('0' + (data.getMonth() + 1)).substr(-1) +
        data.getFullYear() +
        Math.floor(1000 + Math.random() * 9000)
      );
    },
  },
};
</script>

<style scoped>
  div.main-assessoria-digital {
    background-color: #f6f6f6;
    color: #222;
  }

  #header {
    width: 100%;
    height: 500px;
  }

  #header .img__header {
    position: absolute;
    display: block;
    background-image: url('https://app-sistemacpv.s3.amazonaws.com/images/about.jpeg');
    background-repeat: no-repeat;
    background-position: center center;
    width: 100%;
    height: 500px;
    object-fit: cover;
  }

  #header  .bg__escuro {
    background: #00000074;
    background-size: 100% auto !important;
    width: 100%;
    height: 500px;
  }

  #header .bg__title {
    position: relative;
    width: 100%;
    min-height: 50px;
    max-height: 115px;
    padding: 35px 7%;
    top: -23%;
    bottom: 0%;

    display: flex;
    align-items: center;
    justify-content: end !important;

    background-color: #e98a2498;
  }

  #header .h2.text-title {
    color: #fdf3e9;
    font-size: 40px;
    font-weight: 600;
    line-height: 52px; 
    text-shadow: 0 0 8px 8px #fdf3e9;
    text-align: end; 
    display: flex;
    align-items: center;
    justify-content: end;
  }


  h1.display-6 {
    font-size: 1.5rem;
    font-weight: 500;
    line-height: 30px;
    color: #444;
    margin-bottom: 0;
  }

  div.line {
    width: 8%;
    height: 0px;
    position: relative;

    margin: 3px 0 10px;

    border-radius: 4px;
    border: 2px solid;
    border-color: #f8dbbb;
  }

  p.lead {
    font-size: 1.125rem;
    line-height: 24px;
    letter-spacing: 0;
    color: #222;
    margin-bottom: 0px;
  }

  ::v-deep .form-group .input-group .input-group-append .input-group-text {
    background-color: transparent;
    color: #E88A06;
  }

  ::v-deep .form-group .bv-no-focus-ring {
    margin-top: 0.75rem;
  }

  ::v-deep .form-group .bv-no-focus-ring .custom-radio .custom-control-input:not(:disabled):active ~ .custom-control-label::before {
    background-color: #fff;
    border-color: #E88A06;
  }

  ::v-deep .custom-control-input:checked ~ .custom-control-label::before {
    color: #fff;
    border: 5px solid #E88A06;
    background-color: #f6f6f6;
  }

  ::v-deep .btn {
    display: inline-block;
    padding: 8px 16px;

    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0px;

    text-align: center;
    text-transform: uppercase;
    vertical-align: middle;
    user-select: none;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15 ease-in-out;

    color: #E88A06;
    border: 1px solid #E88A06;
    border-radius: 0.25rem;
  }

  ::v-deep .btn:hover {
    color: #fff;
    background-color: #E88A06;
    text-decoration: none;
  }

  ::v-deep .btn:disabled {
    border: 1px solid #e88a0638;
    background-color: #e88a0638;
    color: #E88A06;
    opacity: 0.5;
  }

  ::v-deep .spinner-grow {
    display: inline-block;
    width: 2rem;
    height: 2rem;
    vertical-align: -0125em;
    background-color: #E88A06;
    border-radius: 50%;
    opacity: 0;
    animation: 0.75s linear infinite spinner-grow;
  }
</style>

<!-- <style lang="scss" scoped>
#about__infantil {
  margin-top: 0;

  background-color: #f6f6f6;
  color: #000000;

  p {
    font-size: 14px;
    line-height: 20px;
  }
}

#header {
  width: 100%;
  height: 500px;

  .img__header {
    position: absolute;
    display: block;
    background-image: url('https://app-sistemacpv.s3.amazonaws.com/images/about.jpeg');
    background-repeat: no-repeat;
    background-position: center center;
    width: 100%;
    height: 500px;
    object-fit: cover;
  }

  .bg__escuro {
    background: #00000074;
    background-size: 100% auto !important;
    width: 100%;
    height: 500px;
  }

  .bg__title {
    position: relative;
    width: 100%;
    min-height: 50px;
    max-height: 115px;
    padding: 35px 7%;
    top: -23%;
    bottom: 0%;

    display: flex;
    align-items: center;
    justify-content: end !important;

    background-color: #e98a2498;

    
  }
}

.decorator {
  margin-top: -7px;
  margin-bottom: 20px;
  width: 60px;
  border: 2px solid #f8dbbb;
  border-radius: 8px;
}

.header__form {
  h5 {
    color: #2d1a43;
    font-size: 24px;
    line-height: 32px;
  }

  span {
    color: #2d1a43;
  }
}

.card__sistemacpv {
  border-radius: 8px;
}

.btn__sistemacpv {
  display: inline-flex;
  min-width: auto;
  min-height: auto;

  margin: 20px auto 0;
  padding: 8px 16px;

  gap: 6px;

  background-color: #e98b24;
  border: 1px solid #e98b24;
  border-radius: 5px;

  display: flex;
  align-items: center;

  font-size: 14px;
  line-height: 20px;

  color: #140a1d;

  .icon {
    width: 18px;
    height: 18px;

    display: flex;
    align-items: center;

    i {
      font-size: 16px;
      line-height: 22px;
    }
  }

  span {
    color: #140a1d;
    font-size: 16px;
    line-height: 22px;
  }

  &:hover {
    background-color: #d27d20;
    transition: all 0.3s ease-in-out;
    border: 1px solid #d27d20;
    color: #140a1d;
  }
}
</style> -->
